import { logoutApi } from '@repo/api';
import { AUTH_TOKEN, REFRESH_TOKEN } from '@repo/constants';

const clearLocalAuthState = () => {
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem('clientId');
};

export const logout = async (): Promise<void> => {
  const refreshToken = localStorage.getItem(REFRESH_TOKEN);
  if (refreshToken) {
    try {
      await logoutApi(refreshToken);
    } catch {
      // Backend logout failed — still clear local state per spec
    }
  }
  clearLocalAuthState();
};
